<div appDragScroll
     (mousemove)="$event.stopPropagation()"
     class="pill-container">
  <app-tag-pill *ngFor="let p of pillsIn"
            [pillItem]="p"
            (changed)="changed()">
  </app-tag-pill>
</div>
